import React from 'react';
import { CardActionButton, CardActionLink, CardActionsStyled } from './card-actions.component.style';
// Faixa de botões grandes, colada na base de um card (ex.: "Abrir PDF" | "Assistir vídeo").
export var CardActions = function (_a) {
    var actions = _a.actions, compacta = _a.compacta;
    return (React.createElement(CardActionsStyled, null, actions.map(function (action) {
        return action.href ? (React.createElement(CardActionLink, { key: action.label, compacta: compacta, href: action.href, target: "_blank", rel: "noreferrer", onClick: function (event) { return event.stopPropagation(); } },
            action.icon,
            action.label)) : (React.createElement(CardActionButton, { key: action.label, type: "button", compacta: compacta, onClick: function (event) {
                var _a;
                event.stopPropagation();
                (_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action);
            } },
            action.icon,
            action.label));
    })));
};
